import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
// import TextField from "@material-ui/core/TextField";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
import { Button, Input } from "@material-ui/core";
import DataService from "services/DataService";
import Loading from "components/Loading/loading";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useAlert } from "../../context/Feedback/alertContext";
// import { Button } from "@material-ui/core";
// const percent = "100%";

const useStyles = makeStyles(styles);

export default function RegextoAutomatonDialog(props) {
  const { language, credential } = useUser();
  const {
    setDot,
    setDotName,
    setCreatedDate,
    setArrayElements,
    isActiveDialogRegex,
    setActiveDialogRegex,
    setMachineStates,
    setMachineTransitions,
  } = useDot();
  const { setAlert } = useAlert();

  const [checked, setChecked] = useState(true);
  //   const [spacing] = React.useState(2);
  const [regex, setRegex] = useState("");
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleClose = () => {
    setActiveDialogRegex(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${d}/${m}/${y}-${hh}:${mm}:${ss}`;
  };

  const handleSubmitRegex = async () => {
    if (regex.length > 0) {
      try {
        setLoading(true);

        let regexTemp = regex;
        regexTemp = regexTemp.replace("U", "|");
        setRegex(regexTemp);
        setMachineStates([]);
        setMachineTransitions([]);
        const automaton = await DataService.getAutomatonByRegex(regex, {
          headers: { Authorization: credential },
        });
        setRegex("");
        props.setStars([]); //renderização
        setDot("");
        setArrayElements([]);
        props.setChilds([]); //childs
        setDot(automaton.data);
        const dateNow = new Date();
        setDotName(formatDate(dateNow));
        setCreatedDate(dateNow);
      } catch (e) {
        alert(e);
      }
      setActiveDialogRegex(false);
      setLoading(false);
    } else {
      setAlert({
        active: true,
        text: constants.modal.regexToAutomaton.alert[language],
        color: "danger",
        sevarity: "info",
        icon: ErrorOutlineIcon,
      });
    }
  };

  return (
    <div>
      <Loading loading={loading} />
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogRegex}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          <div className="wrapper-title">
            {constants.modal.regexToAutomaton.title[language]}

            <div className="wrapper-button-close button-margin">
              <Button
                style={{
                  backgroundColor: "#999",
                  color: "#FFF",
                  width: "10px",
                }}
                onClick={handleClose}
              >
                X
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <Input
            className={classes.input}
            placeholder="Regex"
            value={regex}
            fullWidth
            onChange={(e) => setRegex(e.target.value)}
            id="regex-input"
            name="regexInput"
            autoComplete="off"
          />
        </DialogContent>
        <DialogActions className={classes.dialog}>
          <Button
            onClick={() => {
              handleSubmitRegex();
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
